// Modules.
import { connect } from 'react-redux';

// Components.
import HeaderLogoBar from './HeaderLogoBar';

// Store.
const mapStateToProps = state => ({
    gvars: state.global.gvars,
});

export default connect(mapStateToProps)(HeaderLogoBar);
